import React from "react";

export default function Hexagon3() {
  return (
    <svg viewBox="0 0 275.8 279.5" xmlns="http://www.w3.org/2000/svg">
      <path
        d="m7198.8 7061.7-87.4 36.1a31 31 0 0 0 -17.5 19.1l-30.6 97.6a30.6 30.6 0 0 0 11.5 34.1l119.4 84.6a30.6 30.6 0 0 0 36.8-1l74-59a30.5 30.5 0 0 0 10.8-17.4l21.1-96a30.5 30.5 0 0 0 -13.1-32.2l-96.6-63.2a30.8 30.8 0 0 0 -28.4-2.7"
        fill="#00a88e"
        transform="translate(-7061.9 -7059.4)"
      />
    </svg>
  );
}
